module.exports = __webpack_public_path__ + "static/media/loading.90398d77.gif";